module.exports = __webpack_public_path__ + "img/iconVisa3.5fd19e02.png";